import React from "react";
import { Outlet } from "react-router-dom";

function Creneau() {
  return <Outlet />;
}

export default Creneau;
